import { render, staticRenderFns } from "./IconAllInbox.vue?vue&type=template&id=143e95f0"
import script from "./IconAllInbox.vue?vue&type=script&lang=js"
export * from "./IconAllInbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports